// Values < 1000 are shard-scoped (SynchronizationHub joins only the current shard's group), >= 1000 are
// company-scoped (all of the company's shards) — see API.Core/Enums/Transmission/Synchronization/DtoServices.cs.
export enum DtoServices {
  None = 0,
  BookingReferenceService = 140,
  EmployeeService = 1110,
  EmploymentRelationshipService = 1120,
  EmploymentAttributeService = 1130,
  SupplierService = 1210
}
